import { PaginatedArrayService } from '~/services/serviceLivePaginatedArray'
import type { Task } from '~/models/Task'
import { TaskStatus, TaskType } from '~/models/Task'
import {
  where,
  orderBy,
  limit,
  query,
  getCountFromServer,
} from 'firebase/firestore'
import type { DateRange } from './interfaces/dateRange'

export class TaskServicePaginated extends PaginatedArrayService<Task> {
  constructor() {
    super('Tasks')
  }

  public listenForOpenPrescriptionAttachmentTasks(dateRange: DateRange): void {
    let listenQuery = query(
      this.collection,
      where('Type', '==', TaskType.PrescriptionAttachment),
      where('Status', '==', TaskStatus.Pending),
      orderBy('Created', 'desc'),
      limit(this.FETCH_LIMIT),
    )

    listenQuery = this.applyDateFilter(listenQuery, dateRange)

    this.listen(listenQuery)
  }

  public async getOpenPrescriptionAttachmentTaskCount(
    dateRange: DateRange,
  ): Promise<number> {
    let countQuery = query(
      this.collection,
      where('Type', '==', TaskType.PrescriptionAttachment),
      where('Status', '==', TaskStatus.Pending),
    )

    countQuery = this.applyDateFilter(countQuery, dateRange)

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
